import React from 'react';
import LeftMenu from '../common/LeftMenu';
import MyInfo from './MyInfo';
import styles from '@/assets/styles/Profile.module.less';
const Profile: React.FC = () => {
  return ( <main className={styles.profileContainer}>
    <LeftMenu />
    <MyInfo />
  </main> )
};

export default Profile;
